import Component from './ManagePricing'

export default Component
